export const GET_SEARCHINVOICE = "GET_SEARCHINVOICE";
export const GET_SEARCHINVOICE_SUCCESS = "GET_SEARCHINVOICE_SUCCESS";
export const GET_SEARCHINVOICE_FAIL = "GET_SEARCHINVOICE_FAIL";

export const GET_INVOICEVIEW = "GET_INVOICEVIEW";
export const GET_INVOICEVIEW_SUCCESS = "GET_INVOICEVIEW_SUCCESS";
export const GET_INVOICEVIEW_FAIL = "GET_INVOICEVIEW_FAIL";

export const GET_EXPORT_DATA_FOR_VIEW_BUYER = "GET_EXPORT_DATA_FOR_VIEW_BUYER";
export const GET_EXPORT_DATA_FOR_VIEW_BUYER_SUCCESS =
  "GET_EXPORT_DATA_FOR_VIEW_BUYER_SUCCESS";
export const GET_EXPORT_DATA_FOR_VIEW_BUYER_FAIL =
  "GET_EXPORT_DATA_FOR_VIEW_BUYER_FAIL";
export const GET_EXPORT_DATA_FOR_VIEW_BUYER_API_CALL =
  "GET_EXPORT_DATA_FOR_VIEW_BUYER_API_CALL";
export const API_STATUS_VIEW_BUYER = "API_STATUS_VIEW_BUYER";
